import React from "react";
import "../../../style/Infocardemp.css";

const InfoCardEmployee = ({ title, value, icon, iconBg ,bgcolor}) => {
  return (
    <div className="info-card" style={{ backgroundColor: bgcolor }}>
      <div className="info-card-left">
        <p className="info-card-title">{title}</p>
        <h2 className="info-card-value">{value}</h2>
      </div>

      <div
        className="info-card-icon"
      
      >
        {icon}
      </div>
    </div>
  );
};

export default InfoCardEmployee;
